function checkDelivery(){
  var plz=(document.getElementById('dc-input').value||'').trim();
  var res=document.getElementById('dc-result');
  var allowed=['442','443','444','445','446','447','448','451','452','453','454','455','456','457','458','466','472','585','586'];
  res.className='';
  if(!/^\d{5}$/.test(plz)){
    res.className='no';
    res.innerHTML='<strong>Bitte gültige PLZ eingeben</strong>Eine deutsche Postleitzahl besteht aus 5 Ziffern.';
    return;
  }
  var inZone=allowed.some(function(p){return plz.indexOf(p)===0;});
  if(inZone){
    res.className='ok';
    res.innerHTML='<strong>Super - Sie liegen im Liefergebiet!</strong>Wir liefern zu Ihnen. Lagerartikel erreichen Sie in der Regel in 1-3 Werktagen.';
  } else {
    res.className='no';
    res.innerHTML='<strong>Knapp außerhalb unseres Liefergebiets</strong>Für Ihre Region nehmen wir die Lieferung gern individuell auf - oder versenden Kleinteile per Paket. <a href="#b2b" onclick="scrollTo2(\'b2b\')">Jetzt Kontakt aufnehmen →</a>';
  }
}
var _dcInput = document.getElementById('dc-input');
if(_dcInput) _dcInput.addEventListener('keydown',function(e){if(e.key==='Enter')checkDelivery();});

/* ═══════════ PRODUKTDATEN ═══════════ */
const CATS = {
  doener: {
    eyebrow:"01 - Kernsortiment", title:"Döner & Kebab",
    desc:"Alles für den Döner-Imbiss: Tüten, Boxen, Folie, Saucen im Großgebinde und Tortilla. Dönermesser und -grills beschaffen wir auf Anfrage.",
    products:[
      {n:"Dönertüten Kraftpapier weiß",u:'"Döner Kebab" · 16×16 cm · Spenderbox',p:10.92,t:19,s:"stock",a:"1013"},
      {n:"Dönertüten Kraftpapier braun",u:'"Döner Kebab" · 16×16 cm · Spenderbox',p:11.76,t:19,s:"stock",a:"1040"},
      {n:"Dönertüten Kraftpapier",u:'"Gyros Pita" · 16×16 cm · Spenderbox',p:11.99,t:19,s:"stock",a:"1254"},
      {n:"Dönerbox 26 oz weiß",u:"50 Stück / Packung",p:2.93,t:19,s:"stock",a:"1073"},
      {n:"Dönerbox 26 oz schwarz",u:"50 Stück / Packung",p:3.49,t:19,s:"stock",a:"1160"},
      {n:"Dönerbox 16 oz",u:"50 Stück / Packung",p:2.93,t:19,s:"stock",a:"1135"},
      {n:"Dönerbox 26 oz",u:"500 Stück / Karton",p:29.41,t:19,s:"stock",a:"1003"},
      {n:"Dönerbox 16 oz",u:"500 Stück / Karton",p:29.41,t:19,s:"stock",a:"1004"},
      {n:"Gyrosbox 26 oz",u:"50 Stück / Packung",p:6.50,t:19,s:"stock",a:"1082"},
      {n:"Food-to-Go Box Grieche",u:"26 oz · 50 Stück / Packung",p:7.49,t:19,s:"stock",a:"1311"},
      {n:"Dönerfolie lebensmittelecht",u:"20 Rollen / Karton · 380 g/Rolle",p:29.41,t:19,s:"stock",a:"1038"},
      {n:"Dönersauce44 Spezi",u:"10 kg Eimer",p:27.99,t:7,s:"stock",a:"1253"},
      {n:"Dönersauce44 Scharf",u:"10 kg Eimer",p:27.99,t:7,s:"stock",a:"1252"},
      {n:"Dönersauce44 Knoblauch",u:"10 kg Eimer",p:27.99,t:7,s:"stock",a:"1226"},
      {n:"Dönersauce44 Kräuter",u:"10 kg Eimer",p:27.99,t:7,s:"stock",a:"1225"},
      {n:"Antalya Tortilla Dürüm 39 cm",u:"18 Stück / Pack · 1620 g",p:3.99,t:7,s:"stock",a:"1206"},
      {n:"Dönermesser professionell",u:"Wellenschliff · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Dönergrills Gas / Elektro",u:"verschiedene Ausführungen · auf Anfrage",p:null,t:19,s:"req",a:"-"}
    ]
  },
  verpackung: {
    eyebrow:"02 - Kernsortiment", title:"Take-Away & Verpackung",
    desc:"Über 130 Verpackungsartikel ab Lager: Pizzakartons in neun Formaten, Menüboxen, Aluschalen, Becher und Tragetaschen.",
    products:[
      {n:"Pizzakarton Francia 20er",u:"100 Stück · 20×20×4 cm",p:9.24,t:19,s:"stock",a:"1170"},
      {n:"Pizzakarton Francia 24er",u:"100 Stück · 24×24×4 cm",p:11.49,t:19,s:"stock",a:"1325"},
      {n:"Pizzakarton Francia 28er",u:"100 Stück · 28×28×4 cm",p:12.18,t:19,s:"stock",a:"1203"},
      {n:"Pizzakarton Francia 32er",u:"100 Stück · 32×32×4 cm",p:15.96,t:19,s:"stock",a:"1151"},
      {n:"Pizzakarton 40×60×5 cm",u:"50 Stück",p:22.90,t:19,s:"stock",a:"1295"},
      {n:"Pizzakarton 60×60×5 cm",u:"50 Stück",p:34.87,t:19,s:"stock",a:"1327"},
      {n:"IP6 Hamburgerbox groß",u:"125 Stück / Packung",p:7.77,t:19,s:"stock",a:"1008"},
      {n:"IP7 Hamburgerbox klein",u:"100 Stück / Packung",p:4.87,t:19,s:"stock",a:"1009"},
      {n:"Hamburgerbox Giant IP6 XXL",u:"100 Stück · weiß",p:12.99,t:19,s:"stock",a:"1314"},
      {n:"IP4 Menübox 2-geteilt",u:"100 Stück / Packung",p:10.29,t:19,s:"stock",a:"1006"},
      {n:"IP4 Menübox 3-geteilt",u:"100 Stück / Packung",p:10.29,t:19,s:"stock",a:"1005"},
      {n:"Lunchbox Kraft braun 750 ml",u:"50 Stück / Packung",p:8.39,t:19,s:"stock",a:"1294"},
      {n:"Bagasse IP6 kompostierbar",u:"50 Stück / Packung",p:5.99,t:19,s:"stock",a:"1310",h:"art-1310b"},
      {n:"Aluschale R128 + Deckel",u:"100 Stück",p:5.87,t:19,s:"stock",a:"1111"},
      {n:"Aluschale R62L + Deckel",u:"100 Stück",p:9.95,t:19,s:"stock",a:"1304"},
      {n:"Aluschale C804 rund + Deckel",u:"100 Stück",p:9.49,t:19,s:"stock",a:"1302"},
      {n:"Alu-Menüschale 2-teilig + Deckel",u:"100 Stück · 475/710 cc",p:17.79,t:19,s:"stock",a:"1061"},
      {n:"Coffee-to-Go Becher 0,2 L braun",u:"50 Stück / Packung",p:1.67,t:19,s:"stock",a:"1087"},
      {n:"Coffee-to-Go Becher 0,3 L braun",u:"50 Stück / Packung",p:2.61,t:19,s:"stock",a:"1130"},
      {n:"Deckel Coffee-to-Go 0,2-0,3 L",u:"50 Stück / Packung",p:1.34,t:19,s:"stock",a:"1132"},
      {n:"Smoothie-Cup 500 ml RPET",u:"50 Stück / Packung",p:5.29,t:19,s:"stock",a:"1330"},
      {n:"Salatschale BIO Pappe 750 ml",u:"50 Stück",p:6.55,t:19,s:"stock",a:"1163"},
      {n:"Tragetasche 55 cm",u:"2000 Stück / Karton",p:29.41,t:19,s:"stock",a:"1015"},
      {n:"Papiertragetasche groß",u:"250 Stück",p:21.00,t:19,s:"stock",a:"1174"},
      {n:"Aluminiumfolie 14 my",u:"4 Rollen / Karton · 30 cm",p:23.52,t:19,s:"stock",a:"1260"}
    ]
  },
  besteck: {
    eyebrow:"03 - Tischkultur", title:"Besteck & Servietten",
    desc:"Einweg- und Mehrwegbesteck, Strohhalme, Servietten von 1- bis 3-lagig sowie Thermorollen für die Kasse.",
    products:[
      {n:"Plastikgabel Premium Schwarz",u:"1000 Stück / Karton",p:19.33,t:19,s:"stock",a:"1021"},
      {n:"Plastikgabel Premium Transparent",u:"1000 Stück / Karton",p:18.49,t:19,s:"stock",a:"1045"},
      {n:"Plastiklöffel Deluxe schwarz",u:"1000 Stück / Karton",p:21.00,t:19,s:"stock",a:"1054"},
      {n:"Rührstäbchen Holz 14 cm",u:"1000 Stück",p:3.35,t:19,s:"stock",a:"1158"},
      {n:"PP Mehrweg-Strohhalme bunt",u:"250 Stück · 8×240 mm",p:3.35,t:19,s:"stock",a:"1096"},
      {n:"PP Mehrweg-Strohhalme schwarz",u:"250 Stück · 8×240 mm",p:3.35,t:19,s:"stock",a:"1095"},
      {n:"Servietten Premium 1-lagig",u:"33×33 cm · geprägt · 4 kg/Karton",p:11.76,t:19,s:"stock",a:"1012"},
      {n:"Servietten 2-lagig weiß",u:"33×33 cm · 250 Stück",p:6.29,t:19,s:"stock",a:"1259"},
      {n:"Duni Servietten 3-lagig weiß",u:"33×33 cm · 250 Stück",p:7.49,t:19,s:"stock",a:"1175"},
      {n:"Duni Servietten 3-lagig cream",u:"33×33 cm · 250 Stück",p:7.99,t:19,s:"stock",a:"1244"},
      {n:'Feuchttücher "Guten Appetit"',u:"500 Stück · 7×12 cm",p:16.38,t:19,s:"stock",a:"1256"},
      {n:"Buttertöpfchen + Deckel 30 ml",u:"500 Stück",p:9.49,t:19,s:"stock",a:"1171"},
      {n:"Soßenbecher 50 ml rund",u:"500 Stück",p:12.60,t:19,s:"stock",a:"1108"},
      {n:"Pappteller rund 23 cm",u:"500 Stück / Karton",p:5.03,t:19,s:"stock",a:"1043"},
      {n:"Thermorollen 80×80 mm",u:"5 Rollen / Packung",p:4.61,t:19,s:"stock",a:"1321"},
      {n:"Thermorollen EC 57×30 mm",u:"5 Rollen / Packung",p:1.49,t:19,s:"stock",a:"1320"},
      {n:"Thermorollen Lieferando 57×44 mm",u:"5 Rollen / Packung",p:2.76,t:19,s:"stock",a:"1289"}
    ]
  },
  hygiene: {
    eyebrow:"04 - Betriebsbedarf", title:"Reinigung & Hygiene",
    desc:"Profi-Reiniger im Kanister, Hygienepapier in Großpackungen, Nitril-Handschuhe und Müllsäcke. Inklusive unserer Eigenmarke HEK.",
    products:[
      {n:"HEK Kaminreiniger 500 ml",u:"Eigenmarke · Professional",p:2.93,t:19,s:"stock",a:"1310",own:true},
      {n:"Dusty Fettlöser Super Prof. 1 L",u:"12 Stück / Karton",p:2.09,t:19,s:"stock",a:"1074"},
      {n:"Fettlöser 10 L Kanister",u:"10 Liter",p:11.76,t:19,s:"stock",a:"1089"},
      {n:"Spülmittel R2 10 L Kanister",u:"10 Liter",p:12.60,t:19,s:"stock",a:"1026"},
      {n:"R30 Maschinenspülmittel chlorfrei",u:"10 L Kanister",p:25.03,t:19,s:"stock",a:"1083"},
      {n:"R29 Maschinenspülmittel chlorhaltig",u:"10 Liter",p:24.36,t:19,s:"stock",a:"1169"},
      {n:"Glasreiniger R8",u:"10 L Kanister",p:8.40,t:19,s:"stock",a:"1029"},
      {n:"Allzweckreiniger R14",u:"10 L Kanister",p:13.02,t:19,s:"stock",a:"1044"},
      {n:"R22 Grillreiniger",u:"10 Liter",p:15.12,t:19,s:"stock",a:"1196"},
      {n:"Kalklöser Spray 500 ml",u:"mit Sprühpistole",p:1.26,t:19,s:"stock",a:"1049"},
      {n:"Desinfektions-Schaum OXXI",u:"12,5 kg",p:36.13,t:19,s:"stock",a:"1153"},
      {n:"Nitril Handschuhe Schwarz M",u:"100 Stück / Packung",p:3.35,t:19,s:"stock",a:"1034"},
      {n:"Nitril Handschuhe Schwarz L",u:"100 Stück / Packung",p:3.35,t:19,s:"stock",a:"1033"},
      {n:"Nitril Handschuhe Schwarz XL",u:"100 Stück / Packung",p:3.35,t:19,s:"stock",a:"1086"},
      {n:"Toilettenpapier 64 Rollen",u:"2-lagig",p:16.80,t:19,s:"stock",a:"1078"},
      {n:"Handtuchpapier V-Falz",u:"3200 Blatt · 2-lagig",p:21.00,t:19,s:"stock",a:"1079"},
      {n:"Universalrolle TORK",u:"6 Rollen / Packung · 2-lagig",p:11.76,t:19,s:"stock",a:"1016"},
      {n:"Müllsäcke blau LDPE Typ 70",u:"250 Stück / Karton · 120 L",p:25.20,t:19,s:"stock",a:"1018"},
      {n:"Müllsäcke blau LDPE Typ 100",u:"150 Stück / Karton · 120 L",p:29.40,t:19,s:"stock",a:"1019"}
    ]
  },
  food: {
    eyebrow:"05 - Vorbestellung 24-36 h", title:"Lebensmittel & Food",
    desc:"Saucen und Gewürze in Großgebinden, TK-Ware, Frischgemüse, Getränke und Frittieröl. Bestellung 24-36 Stunden im Voraus.",
    food:true,
    products:[
      {n:"Classika Tomatenketchup",u:"10 kg Eimer",p:13.99,t:7,s:"stock",a:"1271"},
      {n:"Classika Curryketchup",u:"10 kg Eimer",p:13.99,t:7,s:"stock",a:"1282"},
      {n:"Classika Salatmayonnaise 50%",u:"10 kg Eimer",p:17.99,t:7,s:"stock",a:"1268"},
      {n:"Wernsing Aioli Soße",u:"3 kg Eimer",p:13.49,t:7,s:"stock",a:"1270"},
      {n:"Oregano gerebelt",u:"1 kg",p:9.99,t:7,s:"stock",a:"1281"},
      {n:"Pfeffer schwarz gemahlen",u:"1 kg",p:13.49,t:7,s:"stock",a:"1273"},
      {n:"Knoblauchpulver",u:"1 kg",p:13.99,t:7,s:"stock",a:"1280"},
      {n:"Aviko Pommes 10 mm",u:"2×5 kg / Karton",p:16.49,t:7,s:"stock",a:"1042"},
      {n:"TK Hähnchennuggets Halal",u:"1 kg",p:4.89,t:7,s:"stock",a:"1324"},
      {n:"TK Hähnchenschnitzel paniert",u:"3 kg · 120 g/Stück",p:20.99,t:7,s:"stock",a:"1266"},
      {n:"Frisch Weißkohl",u:"25 kg Sack",p:8.99,t:7,s:"stock",a:"1264"},
      {n:"Frisch Rotkohl",u:"15 kg Sack",p:7.99,t:7,s:"stock",a:"1263"},
      {n:"Geflügelbratwurst Halal",u:"30×110 g",p:22.99,t:7,s:"stock",a:"1137"},
      {n:"Milram Gauda 48% Blockware",u:"ca. 15 kg",p:4.49,t:7,s:"stock",a:"1247"},
      {n:"Coca-Cola Dose",u:"24×0,33 L",p:12.49,t:19,s:"stock",a:"1199"},
      {n:"Fanta Orange Dose",u:"24×0,33 L",p:11.49,t:19,s:"stock",a:"1284"},
      {n:"Red Bull Energy",u:"24×0,25 L",p:23.49,t:19,s:"stock",a:"1258"},
      {n:"Fritz-Kola",u:"24×0,33 L",p:19.49,t:19,s:"stock",a:"1234"},
      {n:"Haydi Ayran frisch",u:"20×250 ml",p:6.99,t:7,s:"stock",a:"1237"},
      {n:"Frittieröl 10 L Kanister",u:"10 Liter",p:20.55,t:7,s:"stock",a:"1002"},
      {n:"Frittieröl 20 L Kanister",u:"20 Liter",p:41.12,t:7,s:"stock",a:"1036"},
      {n:"Sonnenblumenöl 10 L Kanister",u:"10 Liter",p:15.41,t:7,s:"stock",a:"1181"}
    ]
  },
  branding: {
    eyebrow:"06 - Auf Anfrage", title:"Branding-Service",
    desc:"Ihr Logo auf Verpackung und Besteck - ab definierten Mindestmengen. Wir beraten Sie kostenlos zu Format, Druck und Stückzahl.",
    products:[
      {n:"Dönertüten Individualdruck",u:"ab 1.000 Stück · weiß oder braun · 16×16 cm",p:null,t:19,s:"req",a:"-"},
      {n:"Coffee-to-Go Becher mit Druck",u:"ab 500 Stück · 0,2 / 0,3 L",p:null,t:19,s:"req",a:"-"},
      {n:"Servietten mit Firmendruck",u:"ab 1.000 Stück · 1-3-lagig · 33×33 cm",p:null,t:19,s:"req",a:"-"},
      {n:"Papiertragetaschen mit Logo",u:"ab 500 Stück · 48 / 55 cm",p:null,t:19,s:"req",a:"-"},
      {n:"Besteck mit Druck oder Gravur",u:"ab 1.000 Stück · Plastik oder Holz",p:null,t:19,s:"req",a:"-"},
      {n:"Komplettpaket Corporate Identity",u:"alle Verpackungen einheitlich · kostenlose Beratung",p:null,t:19,s:"req",a:"-"}
    ]
  },
  moebel: {
    eyebrow:"07 - Auf Anfrage", title:"Möbel & Einrichtung",
    desc:"Gastro-Möbel und Einrichtungslösungen für Ihr Lokal - Stühle, Tische, Tresen und Theken. Persönliche Beratung und Beschaffung auf Anfrage.",
    products:[
      {n:"Gastro-Stühle stapelbar",u:"verschiedene Ausführungen und Materialien · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Bistrotische rund",u:"ø 60 / 70 cm · verschiedene Höhen · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Bar-Hocker",u:"Holz oder Metall · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Tresen & Bedientheken",u:"individuell nach Maß · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Sitzpolster & Sitzbänke",u:"für Gastronomie · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Kompletteinrichtung Lokal",u:"Planung und Beschaffung · kostenlose Beratung",p:null,t:19,s:"req",a:"-"}
    ]
  },
  sonder: {
    eyebrow:"08 - Sonderbeschaffung", title:"Individuelle Lösungen",
    desc:"Was nicht im Standardsortiment ist, beschaffen wir. Dönergeräte, Spezialformate, Großmengen und Sonderwünsche - persönlich und unkompliziert.",
    products:[
      {n:"Dönergrills Gas / Elektro",u:"verschiedene Fabrikate und Ausführungen · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Dönermesser elektrisch",u:"professioneller Wellenschliff · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Sonderformate Verpackung",u:"Spezialmaße außerhalb des Standardsortiments · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Großmengen-Bestellung",u:"Konditionen ab Palettenabnahme · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Erweitertes Sortiment",u:"Artikel außerhalb des Webshops · auf Anfrage",p:null,t:19,s:"req",a:"-"},
      {n:"Individuelle Anfrage",u:"Sonderwünsche aller Art · persönliche Beratung",p:null,t:19,s:"req",a:"-"}
    ]
  }
};

/* ═══════════ STATE ═══════════ */
let cart = [];
const fmt = n => n.toFixed(2).replace(".", ",") + " €";
const PROD_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 9l9-6 9 6v9a1 1 0 01-1 1H4a1 1 0 01-1-1z"/><path d="M3 9l9 6 9-6"/></svg>';

/* ═══════════ CATEGORY / PRODUCT VIEW ═══════════ */
const ALL_SECS = "#hero,#intro,#cats,#features,#label,#story,#b2b,#deals,#reviews,#delivery,#nl";
let catFrom = "cats"; /* track which section triggered openCat for correct back-nav */

function openCat(id, fromSection){
  const cat = CATS[id]; if(!cat) return;
  catFrom = fromSection || "cats";
  document.querySelectorAll(ALL_SECS).forEach(s=>s.style.display="none");
  const pv = document.getElementById("pv");
  pv.style.display = "block";
  document.getElementById("pv-eyebrow").textContent = cat.eyebrow;
  document.getElementById("pv-title").textContent = cat.title;
  document.getElementById("pv-desc").textContent = cat.desc;
  document.getElementById("pv-count").textContent = cat.products.length + " Artikel";
  document.getElementById("pv-foodnote").innerHTML = cat.food
    ? '<div class="food-note"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg><div class="food-note-t"><strong>Hinweis zur Bestellung von Lebensmitteln</strong>Bitte mindestens 24-36 Stunden im Voraus bestellen. Die Lieferung erfolgt abhängig von Bestellvolumen und Entfernung. Frisch- und TK-Ware nach Absprache - gern telefonisch unter +49 176 44224498.</div></div>'
    : "";
  const grid = document.getElementById("pv-grid");
  grid.innerHTML = cat.products.map((p,i)=>{
    const handle = (p.a && p.a !== "-") ? `/products/${p.h || "art-" + p.a}` : null;
    const nameHtml = handle
      ? `<a href="${handle}" class="pc-name-link"><h3 class="pc-name">${p.n}</h3></a>`
      : `<h3 class="pc-name">${p.n}</h3>`;
    const imgHtml = p.img
      ? `<img src="${p.img}" alt="${p.n}" loading="lazy" style="width:100%;height:100%;object-fit:cover;border-radius:8px">`
      : PROD_ICON;
    return `
    <article class="pc reveal" style="transition-delay:${(i%3)*.07}s">
      <div class="pc-img">
        ${imgHtml}
        <span class="pc-badge ${p.s==="stock"?"pb-stock":"pb-req"}">${p.s==="stock"?(p.own?"Eigenmarke":"Ab Lager"):"Auf Anfrage"}</span>
        <span class="pc-art">${p.a}</span>
        ${handle ? `<a href="${handle}" class="pc-detail-link" title="Produktseite">Mehr Details →</a>` : ""}
      </div>
      <div class="pc-body">
        ${nameHtml}
        <p class="pc-unit">${p.u}</p>
        <div class="pc-foot">
          ${p.p!=null
            ? `<div class="pc-price">${fmt(p.p)}<span class="tax">zzgl. ${p.t}% MwSt.</span></div><button class="pc-add" onclick="addToCart('${id}',${i})" aria-label="In den Warenkorb"><svg viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14"/></svg></button>`
            : `<div class="pc-price req">Preis auf Anfrage</div><button class="pc-add req" onclick="addToCart('${id}',${i})"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>Anfragen</button>`}
        </div>
      </div>
    </article>`;
  }).join("");
  window.scrollTo({top:0,behavior:"instant"});
  setTimeout(()=>document.querySelectorAll("#pv-grid .reveal").forEach(el=>el.classList.add("in")),50);
  document.getElementById("hdr").classList.add("solid");
}

function closeCat(){
  document.getElementById("pv").style.display="none";
  document.querySelectorAll(ALL_SECS).forEach(s=>s.style.display="");
  scrollTo2(catFrom);
}

function goHome(e){
  if(e) e.preventDefault();
  if(window.location.pathname==="/" || window.location.pathname===""){
    var pv=document.getElementById("pv");
    if(pv) pv.style.display="none";
    document.querySelectorAll(ALL_SECS).forEach(function(s){if(s) s.style.display="";});
    window.scrollTo({top:0,behavior:"smooth"});
  } else {
    window.location.href="/";
  }
}

/* ═══════════ CART (Shopify API) ═══════════ */
function loadShopifyCart(){
  return fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(sc){
      cart = sc.items.map(function(item){
        return {
          n: item.product_title,
          u: (item.variant_title && item.variant_title!=='Default Title') ? item.variant_title : (item.sku||''),
          p: item.price/100,
          t: 19,
          a: item.sku || String(item.variant_id),
          q: item.quantity,
          key: item.key,
          variantId: item.variant_id
        };
      });
      return cart;
    });
}

function addToCart(catId,i){
  var p = CATS[catId].products[i];
  if(p.s==="req"){ openKontakt(); return; }
  var handle = p.h || ("art-"+p.a);
  fetch("/products/"+handle+".js")
    .then(function(r){ if(!r.ok) throw new Error("not found"); return r.json(); })
    .then(function(prod){
      return fetch("/cart/add.js",{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({id:prod.variants[0].id,quantity:1})
      });
    })
    .then(function(r){ if(!r.ok) throw new Error("add failed"); return loadShopifyCart(); })
    .then(function(){ renderCart(); toast(p.n+" hinzugefügt"); })
    .catch(function(){
      /* Fallback: lokale Liste wenn Produkt noch nicht in Shopify */
      var ex=cart.find(function(c){return c.a===p.a&&c.n===p.n;});
      if(ex) ex.q++;
      else cart.push({n:p.n,u:p.u,p:p.p,t:p.t,a:p.a,q:1});
      renderCart(); toast(p.n+" hinzugefügt");
    });
}
function removeItem(i){
  var item=cart[i];
  if(item&&item.key){
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({id:item.key,quantity:0})})
    .then(loadShopifyCart).then(renderCart);
  } else { cart.splice(i,1); renderCart(); }
}
function chgQty(i,d){
  var item=cart[i]; var nq=item.q+d;
  if(item&&item.key){
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({id:item.key,quantity:Math.max(0,nq)})})
    .then(loadShopifyCart).then(renderCart);
  } else { item.q=nq; if(item.q<=0) cart.splice(i,1); renderCart(); }
}
function cartCount(){ return cart.reduce(function(s,i){return s+i.q;},0); }
function cartNet(){ return cart.reduce(function(s,i){return s+i.p*i.q;},0); }
function cartGross(){ return cart.reduce(function(s,i){return s+i.p*i.q*(1+i.t/100);},0); }

function renderCart(){
  const n = cartCount();
  const dot = document.getElementById("cart-dot");
  dot.textContent = n; dot.style.display = n>0?"flex":"none";
  const body = document.getElementById("cart-body");
  const foot = document.getElementById("cart-foot");
  if(!cart.length){
    body.innerHTML = '<div class="cart-empty"><div class="cart-empty-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg></div><p>Noch nichts ausgewählt</p><span>Entdecken Sie unser Sortiment</span></div>';
    foot.innerHTML = ""; return;
  }
  body.innerHTML = cart.map((it,i)=>`
    <div class="ci">
      <div class="ci-img">${PROD_ICON}</div>
      <div class="ci-info">
        <div class="ci-n">${it.n}</div>
        <div class="ci-u">${it.u}</div>
        <div class="ci-controls">
          <div class="ci-qty"><button class="qb" onclick="chgQty(${i},-1)">−</button><span class="qv">${it.q}</span><button class="qb" onclick="chgQty(${i},1)">+</button></div>
          <div class="ci-price">${fmt(it.p*it.q)}</div>
        </div>
        <button class="ci-rm" onclick="removeItem(${i})" style="margin-top:8px">Entfernen</button>
      </div>
    </div>`).join("");
  foot.innerHTML = `
    <div class="cart-foot">
      <div class="cart-tr"><span>Zwischensumme (netto)</span><span>${fmt(cartNet())}</span></div>
      <div class="cart-tr total"><span>Gesamt</span><span>${fmt(cartGross())}</span></div>
      <div class="cart-tax">inkl. MwSt. · zzgl. Versand (wird im Checkout berechnet)</div>
      <button class="cart-co" onclick="startCheckout()">Zur Kasse <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>
      <button class="cart-cont" onclick="toggleCart()">Weiter einkaufen</button>
    </div>`;
}
function toggleCart(){
  var cartEl=document.getElementById("cart");
  var cartOv=document.getElementById("cart-ov");
  var wasOpen=cartEl.classList.contains("on");
  cartEl.classList.toggle("on");
  if(cartOv) cartOv.classList.toggle("on");
  if(!wasOpen){
    loadShopifyCart().then(renderCart).catch(renderCart);
  }
}

/* ═══════════ CHECKOUT ═══════════ */
function startCheckout(){
  /* Cart-Drawer schließen, dann direkt zum Shopify-Checkout */
  var cartEl=document.getElementById("cart");
  var cartOv=document.getElementById("cart-ov");
  if(cartEl) cartEl.classList.remove("on");
  if(cartOv) cartOv.classList.remove("on");
  window.location.href="/checkout";
}
function closeCheckout(){
  var co=document.getElementById("co");
  if(co) co.classList.remove("on");
}

/* ═══════════ FORMS ═══════════ */
/* Kontakt- & B2B-Anfrage-Erfolg: nach dem nativen Shopify-POST (/contact)
   kommt die Seite mit ?contact_posted=true zurück. Wir zeigen die Erfolgs-
   meldung gezielt beim richtigen Formular (per sessionStorage-Markierung). */
window.addEventListener("load", function(){
  if(!/[?&]contact_posted=true/.test(location.search)) return;
  var which = "";
  try { which = sessionStorage.getItem("hekForm") || ""; sessionStorage.removeItem("hekForm"); } catch(e){}
  function show(successId, fieldsId){
    var s=document.getElementById(successId), f=document.getElementById(fieldsId);
    if(s) s.style.display="block";
    if(f) f.style.display="none";
  }
  if(which==="b2b"){
    show("b2b-success","b2b-fields");
    var b=document.getElementById("b2b"); if(b) b.scrollIntoView({behavior:"smooth",block:"center"});
  } else {
    /* 'modal' oder Fallback (kein Marker) → Kontakt-Fenster mit Erfolg zeigen */
    show("km-success","km-fields");
    if(window.openKontakt) openKontakt();
  }
});

/* ═══════════ TOAST ═══════════ */
let toastT;
function toast(msg){
  document.getElementById("toast-msg").textContent = msg;
  const t = document.getElementById("toast");
  t.classList.add("on"); clearTimeout(toastT);
  toastT = setTimeout(()=>t.classList.remove("on"), 2800);
}

/* ═══════════ NAV ═══════════ */
function scrollTo2(id){
  var pv=document.getElementById("pv");
  if(pv && pv.style.display==="block"){
    pv.style.display="none";
    document.querySelectorAll(ALL_SECS).forEach(function(s){if(s) s.style.display="";});
  }
  var el=document.getElementById(id);
  if(el) setTimeout(function(){el.scrollIntoView({behavior:"smooth",block:"start"});},60);
}

/* ═══════════ HEADER SCROLL ═══════════ */
addEventListener("scroll",function(){
  var hdr=document.getElementById("hdr");
  if(hdr) hdr.classList.toggle("solid",scrollY>60);
});

/* ═══════════ HERO LOAD ═══════════ */
addEventListener("load",function(){var h=document.getElementById("hero");if(h)h.classList.add("loaded");});

/* ═══════════ HERO PARALLAX ═══════════ */
(function(){
  var heroImg = document.querySelector(".hero-media img");
  if(!heroImg) return;
  var lastY = 0, ticking = false;
  function applyParallax(){
    if(window.HEK_ANIM && window.HEK_ANIM.parallax === false){ heroImg.style.transform=''; ticking=false; return; }
    var y = window.scrollY;
    var wh = window.innerHeight;
    if(y < wh * 1.5){
      var scale = 1.08;
      var ty = y * 0.18;
      heroImg.style.transform = "scale(" + scale + ") translateY(" + ty + "px)";
    }
    ticking = false;
  }
  window.addEventListener("scroll", function(){
    if(!ticking){ requestAnimationFrame(applyParallax); ticking = true; }
  }, {passive: true});
})();

/* ═══════════ SCROLL REVEAL ═══════════ */
const io = new IntersectionObserver((es)=>{
  es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target);
    if(e.target.querySelector("[data-count]") || e.target.hasAttribute("data-count")) animCount(e.target); } });
},{threshold:.15, rootMargin:"0px 0px -40px 0px"});
document.querySelectorAll(".reveal,.reveal-line").forEach(el=>io.observe(el));

/* counters */
const countIO = new IntersectionObserver((es)=>{
  es.forEach(e=>{ if(e.isIntersecting){ animCount(e.target); countIO.unobserve(e.target); } });
},{threshold:.5});
document.querySelectorAll("[data-count]").forEach(el=>countIO.observe(el));
function animCount(el){
  const node = el.hasAttribute("data-count") ? el : el.querySelector("[data-count]");
  if(!node || node._done) return; node._done=true;
  const tgt=+node.dataset.count, suf=node.dataset.suf||"";
  let s=null;
  requestAnimationFrame(function go(ts){
    if(!s)s=ts; const p=Math.min((ts-s)/1500,1), e=1-Math.pow(1-p,3);
    node.textContent=Math.round(e*tgt)+suf;
    if(p<1) requestAnimationFrame(go);
  });
}

/* ═══════════ PRIVATE LABEL TILT ═══════════ */
var lp = document.getElementById("labelProduct");
if(lp){
  var vis = lp.closest(".label-visual");
  if(vis){
    vis.addEventListener("mousemove",function(e){
      var r=vis.getBoundingClientRect();
      var x=(e.clientY-r.top-r.height/2)/(r.height/2)*-6;
      var y=(e.clientX-r.left-r.width/2)/(r.width/2)*6;
      lp.style.transform="perspective(800px) rotateX("+x+"deg) rotateY("+y+"deg)";
    });
    vis.addEventListener("mouseleave",function(){lp.style.transform="perspective(800px) rotateX(0) rotateY(0)";});
  }
}

/* ═══════════ KONTAKT MODAL ═══════════ */
function openKontakt(){
  document.getElementById("kontakt-ov").classList.add("on");
  document.body.style.overflow="hidden";
}
function closeKontakt(){
  document.getElementById("kontakt-ov").classList.remove("on");
  document.body.style.overflow="";
}
function openMobNav(){
  document.getElementById("mob-nav").classList.add("open");
  document.getElementById("mob-burger").classList.add("open");
  document.body.style.overflow="hidden";
}
function closeMobNav(){
  document.getElementById("mob-nav").classList.remove("open");
  document.getElementById("mob-burger").classList.remove("open");
  document.body.style.overflow="";
}
function toggleMobCat(btn){
  var cat=btn.parentNode;
  cat.classList.toggle("open");
}
function toggleMegaCat(btn){
  var cat=btn.parentNode;
  cat.classList.toggle("open");
}

/* ═══════════ SEARCH ═══════════ */
function openSearch(){
  document.getElementById("search-ov").classList.add("on");
  document.body.style.overflow="hidden";
  setTimeout(()=>document.getElementById("search-input").focus(),80);
}
function closeSearch(){
  document.getElementById("search-ov").classList.remove("on");
  document.body.style.overflow="";
  clearSearch();
}
function clearSearch(){
  document.getElementById("search-input").value="";
  document.getElementById("search-clear").classList.remove("visible");
  document.getElementById("search-results").innerHTML='<div class="search-hint"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>Tippen Sie einen Produktnamen oder eine Kategorie ein …</div>';
}
function searchKey(e){
  if(e.key==="Escape"){ closeSearch(); return; }
  if(e.key==="Enter"){
    var q=document.getElementById("search-input").value.trim();
    if(q.length>0){ window.location.href="/search?type=product&q="+encodeURIComponent(q); }
  }
}
var CAT_LABELS={doener:"Döner & Kebab",verpackung:"Take-Away & Verpackung",besteck:"Besteck & Servietten",hygiene:"Reinigung & Hygiene",food:"Lebensmittel & Food",branding:"Branding-Service",moebel:"Möbel & Einrichtung",sonder:"Individuelle Lösungen"};
var CAT_ICONS={
  doener:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 7h18M3 12h18M3 17h18"/></svg>',
  verpackung:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 9l9-6 9 6v9a1 1 0 01-1 1H4a1 1 0 01-1-1z"/></svg>',
  besteck:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 3v18M7 5v5a4 4 0 008 0V5"/></svg>',
  hygiene:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
  food:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="12" r="9"/><path d="M8 13s1.5 2 4 2 4-2 4-2"/></svg>',
  branding:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 19h8M16 3.5a2.1 2.1 0 013 3L8 17.5l-4 1 1-4z"/></svg>',
  moebel:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 7h18M3 7v13M21 7v13M3 13h18"/></svg>',
  sonder:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>'
};
var _searchTimer=null, _searchSeq=0;
function runSearch(q){
  var clear=document.getElementById("search-clear");
  var res=document.getElementById("search-results");
  q=q.trim();
  clear.classList.toggle("visible",q.length>0);
  if(q.length<2){
    res.innerHTML='<div class="search-hint"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>Tippen Sie einen Produktnamen oder eine Artikel-Nr. ein …</div>';
    return;
  }
  /* Debounce: echte Shopify-Suche abfragen */
  clearTimeout(_searchTimer);
  _searchTimer=setTimeout(function(){ doShopifySearch(q); }, 220);
}
function doShopifySearch(q){
  var res=document.getElementById("search-results");
  var seq=++_searchSeq;
  res.innerHTML='<div class="search-hint"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>Suche läuft …</div>';
  var url="/search/suggest.json?q="+encodeURIComponent(q)+"&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor";
  fetch(url,{headers:{"Accept":"application/json"}})
    .then(function(r){ return r.json(); })
    .then(function(data){
      if(seq!==_searchSeq) return; /* veraltete Antwort verwerfen */
      var products=(data.resources && data.resources.results && data.resources.results.products) || [];
      if(!products.length){
        res.innerHTML='<div class="search-empty"><strong>Kein Ergebnis</strong>Kein Produkt gefunden für „'+escHtml(q)+'". Versuchen Sie ein anderes Stichwort oder <button onclick="closeSearch();openKontakt()" style="color:var(--green);font-weight:600;cursor:pointer;background:none;border:none;font-size:15px;padding:0">schreiben Sie uns direkt</button>.</div>';
        return;
      }
      var html='';
      products.forEach(function(p){
        var img=p.featured_image && p.featured_image.url
          ? '<img src="'+p.featured_image.url+'" alt="'+escHtml(p.title)+'" loading="lazy" style="width:100%;height:100%;object-fit:contain">'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M3 9l9-6 9 6v9a1 1 0 01-1 1H4a1 1 0 01-1-1z"/><path d="M3 9l9 6 9-6"/></svg>';
        var priceHtml = (p.price!=null)
          ? '<span class="sr-price">'+fmtMoney(p.price)+'</span>'
          : '';
        var avail = p.available!==false;
        var badge = avail ? '<span class="sr-badge">Lager</span>' : '<span class="sr-badge req-badge">Anfrage</span>';
        var sub = p.product_type || p.vendor || '';
        html+='<a class="sr-item" href="'+p.url+'">'+
          '<div class="sr-item-left">'+
          '<div class="sr-ic">'+img+'</div>'+
          '<div><div class="sr-name">'+escHtml(p.title)+'</div><div class="sr-unit">'+escHtml(sub)+'</div></div>'+
          '</div>'+
          '<div style="display:flex;align-items:center;gap:8px;flex-shrink:0">'+badge+priceHtml+'</div>'+
          '</a>';
      });
      html+='<a class="sr-all" href="/search?type=product&q='+encodeURIComponent(q)+'">Alle Ergebnisse für „'+escHtml(q)+'" anzeigen →</a>';
      res.innerHTML=html;
    })
    .catch(function(){
      if(seq!==_searchSeq) return;
      res.innerHTML='<div class="search-empty"><strong>Suche nicht verfügbar</strong>Bitte versuchen Sie es erneut oder <button onclick="closeSearch();openKontakt()" style="color:var(--green);font-weight:600;cursor:pointer;background:none;border:none;font-size:15px;padding:0">schreiben Sie uns direkt</button>.</div>';
    });
}
/* Shopify-Preise kommen in Cent (Integer) - in Euro formatieren */
function fmtMoney(cents){
  return (cents/100).toFixed(2).replace(".",",")+" €";
}
function escHtml(s){return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}
var kmType = "privat";
function setKmType(t){
  kmType = t;
  var p=document.getElementById("km-priv"), b=document.getElementById("km-biz");
  if(p) p.classList.toggle("active", t==="privat");
  if(b) b.classList.toggle("active", t==="business");
  var cf = document.getElementById("km-company-field");
  if(cf){ cf.classList.toggle("hidden", t==="privat"); cf.classList.toggle("visible", t==="business"); }
  var kt = document.getElementById("km-kundentyp");
  if(kt) kt.value = (t==="business" ? "Unternehmen" : "Privatkunde");
}
/* ═══════════ ESC closes all overlays ═══════════ */
document.addEventListener("keydown",function(e){
  if(e.key==="Escape"){
    var cartEl=document.getElementById("cart");
    var cartOv=document.getElementById("cart-ov");
    var coEl=document.getElementById("co");
    if(cartEl) cartEl.classList.remove("on");
    if(cartOv) cartOv.classList.remove("on");
    if(coEl) coEl.classList.remove("on");
    closeKontakt();
    closeSearch();
  }
});

/* Warenkorb beim Laden synchronisieren */
loadShopifyCart().then(renderCart).catch(renderCart);


/* 3D-Tilt bei Karten (optional, via Animationen-Einstellung) */
(function(){
  if(!(window.HEK_ANIM && window.HEK_ANIM.tilt)) return;
  function bind(card){
    card.style.transformStyle='preserve-3d';
    card.style.willChange='transform';
    card.addEventListener('mousemove',function(e){
      var r=card.getBoundingClientRect();
      var px=(e.clientX-r.left)/r.width-0.5, py=(e.clientY-r.top)/r.height-0.5;
      card.style.transform='perspective(820px) rotateX('+(-py*6).toFixed(2)+'deg) rotateY('+(px*6).toFixed(2)+'deg) translateY(-4px)';
    },{passive:true});
    card.addEventListener('mouseleave',function(){ card.style.transform=''; },{passive:true});
  }
  function init(){ document.querySelectorAll('.pc-card,.cat-card').forEach(bind); }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',init); }
})();
